import {Component, Input} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {VariationsDialogComponent} from '@emm/common-items/dialogs/variations-dialog/variations-dialog.component';

@Component({
  selector: 'emm-quick-view-button',
  templateUrl: './quick-view-button.component.html',
  styleUrl: './quick-view-button.component.scss'
})
export class QuickViewButtonComponent {
    @Input() item;
    @Input() variations;
    constructor(private dialog: MatDialog) {}

    openVariationsDialog(): void {
        this.dialog.open(VariationsDialogComponent, {
            width: '750px',
            height: '500px',
            data: {
                item: this.item,
                variations: this.variations,
            }
        });
    }
}
